<app-table
    #templatesTable
    [gridData]="store.data.getEPrescriptionMagistraliterTemplates()"
    [refreshCallback]="store.api.getEPrescriptionMagistraliterTemplates"
    [refreshCallbackFragment]="tableFrag"
    [columns]="columns"
    [defaultSorters]="{ column: 'name', direction: 'ASC' }"
    translatePrefix="ePrescriptions.magistraliterTemplates."
    selectionMode="single"
    (selectionChanged)="selectionChanged($event)"
    (deleteCallbackWithEvent)="deleteTemplate($event)"
></app-table>

<div #dialogFooter class="p-dialog-footer">
    <app-action-buttons
        primaryButtonType="custom"
        primaryButtonIcon="pi-folder-open"
        primaryButtonLabel="ePrescriptions.buttons.loadTemplate"
        [primaryButtonDisability]="!selectedTemplate()"
        (primaryClickEvent)="loadTemplate()"
        (secondaryClickEvent)="dialogRef.close()"
    ></app-action-buttons>
</div>
